export enum EnEmailMessageStatus {
    success = 'success',
    error = 'error'
}
